var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.1 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Drkcls-1 {\n        fill: #002c3d;\n      }\n\n      .Drkcls-2 {\n        fill: none;\n      }\n\n      .Drkcls-2, .Drkcls-3 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .Drkcls-3 {\n        fill: #d81159;\n      }\n\n      .Drkcls-4 {\n        fill: #011936;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_84",
    "data-name": "Layer 84"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-1",
    x: 22.48,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 22.48,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_83",
    "data-name": "Layer 83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 32.64,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 32.64,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_82",
    "data-name": "Layer 82"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 100.95,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 100.95,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_81",
    "data-name": "Layer 81"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 168.43,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 168.43,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_80",
    "data-name": "Layer 80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 33.05,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 33.05,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_79",
    "data-name": "Layer 79"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 101.37,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 101.37,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_78",
    "data-name": "Layer 78"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 168.85,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 168.85,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_77",
    "data-name": "Layer 77"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 33.05,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 33.05,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_76",
    "data-name": "Layer 76"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 101.37,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 101.37,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_75",
    "data-name": "Layer 75"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-4",
    x: 168.85,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Drkcls-2",
    x: 168.85,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Drkcls-3",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/Dark.3b36fec88faa6ccecdcba21a09d96b0e.svg";
export { ForwardRef as ReactComponent };